<template>
  <div>
    <h1 class="c-heading-1">Persoonlijke begeleiding</h1>
    <p>UNIZO wilt je graag begeleiden en de volgende stappen met je afleggen via een gepersonaliseerde begeleiding.</p>
    <p>Indien je honger hebt naar meer kennis of begeleiding rond innovatie, persoonlijk en volledig op maat, doe dan beroep op de FutureForward-coaches van UNIZO. Zij hebben een begeleidingsprogramma ontwikkeld dat je een heel eind verder brengt.</p>
    <p>De FutureForward- coaches staan voor je klaar!</p>
    <div class="c-toolbar c-toolbar--split">
      <div></div>
      <div>
        <navigation-button to="coachingconfirmation" @click="setWantsCoaching(true)">Ja, ik wens door mijn FutureForward-coach gecontacteerd te worden</navigation-button>
        <router-link to="coachingconfirmation" class="no-coaching" @click="setWantsCoaching(false)">Neen, stuur me mijn resultaten &raquo;</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationButton from '../components/NavigationButton'
export default {
  components: {
    NavigationButton
  },
  methods: {
    setWantsCoaching (status) {
      this.$store.commit('updateWantsCoaching', status);
      this.$store.dispatch('updateDatabaseRecord')
    }
  }
}
</script>

<style lang="scss">
.no-coaching {
  display: block;
  margin-top: 2.4rem;
}
</style>
